import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, ToastController, Events } from 'ionic-angular';

@Injectable()
export class StationsProvider {

  public stations:any = [];
  public stationsDetails:any = [];

  public apiUrl:string = './assets/stations.json';
  public stationsDetailsUrl:string = './assets/stations-full.json';

  // public stationsDetailsApiUrl:string = 'https://dzt.local/api/dzt-station.php';
  public stationsDetailsApiUrl:string = 'https://www.dzairtransport.com/api/dzt-station.php';

  constructor(public http: HttpClient, private alertCtrl: AlertController, private toastCtrl: ToastController, public events: Events) {
    this.loadStations();
  }
  /* ######################################################################
     Affichage d'un message
  ###################################################################### */
  private presentAlert(subTitle, title?) {
    let alert = this.alertCtrl.create({
      title: (title?title:''),
      subTitle: subTitle,
      buttons: ['Ok']
    });
    alert.present();
  }

  /* ######################################################################
     Chargement des stations (local)
  ###################################################################### */
  private loadStations() {
    // Chargement des stations
    this.http.get(this.apiUrl).subscribe(data =>
    {
      this.stations = data;
    }, err => {
      console.log(err);
    });

    // Chargement des details des stations
    var $build_app = true;
    if ($build_app) {   // BUILD pour Mobile (Chargement des stations en local)
      this.http.get(this.stationsDetailsUrl).subscribe(data =>
      {
        this.stationsDetails = data;
        // console.log("Stations details loaded !");
      }, err => {
        // console.log(err);
      });
    }
  }

  /* ######################################################################
     Affichage des details d'une station (local)
  ###################################################################### */
  public showStationDetails(item) {
    // Vérifier si les details des stations existent en local
    if (this.stationsDetails.length>0) {
      // Récupération des détails à partir de this.stations préalablement chargé avec loadStations()
      var stationDetails = this.stationsDetails.filter(function(element) {
          // return (element.sname == item.sname) && (element.cname ==item.cname);
          return element.post_name == item.post_name;
        });
      if (stationDetails.length>0) {
        return stationDetails[0];
      } else {
        return false;
      }
    } else {
      // Charger les details de la station de l'API
      this.getStationDetails(item);
      return false;
    }
  }

  /* ######################################################################
     Chargement et Affichage des details d'une station (remote)
  ###################################################################### */
  public getStationDetails(item) {
    // Presentation du Loading
    let toast = this.toastCtrl.create({
      message: 'Chargement',
      duration: 10000,
      position: 'top'
    });
    toast.onDidDismiss(() => { });
    toast.present();

    this.http.get(this.stationsDetailsApiUrl + '?post_name=' + item.post_name)
      .timeout(8000)
      .subscribe(data =>
      {
        if ((data['status']) && (data['status']=="fail")) {
          console.log("Error getting station details", data['message']);
          this.presentAlert(data['message']);
        } else {
          this.events.publish('stationDetails:received', data);
        }
        return data;
      }, err => {
        console.log(err.message);
        this.presentAlert("Veuillez vérifier votre connection internet.", "Connection");
        toast.dismiss();
      }, () => {
        // console.log("HTTP request done !");
        toast.dismiss();
      });
  }

  private removeAccents(text) {
    let latin_map = {
    'à': 'a',
    'ä': 'a',
    'â': 'a',
    'é': 'e',
    'è': 'e',
    'ê': 'e',
    'ë': 'e',
    'î': 'i',
    'ï': 'i',
    'ç': 'c',
    'û': 'e',
    'ù': 'u',
    'ô': 'o',
    'ö': 'o'
    };
	  return text.replace(/[^A-Za-z0-9]/g, function(x) { return latin_map[x] || x; })
  };
  filterItems(searchTerm){
    if (searchTerm.length>2) {
      return this.stations.filter((station) => {
        return this.removeAccents((station.sname + ', ' + station.cname).toLowerCase()).indexOf(this.removeAccents(searchTerm.toLowerCase())) > -1;
      });
    } else {
      return [];
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/stations/stations.ts